import dayjs from 'dayjs'

export const getMexicoTime = () => {
  const d = new Date()

  const utc = d.getTime() + d.getTimezoneOffset() * 60000
  const nd = new Date(utc + 3600000 * -6).toString()

  return dayjs(nd)
}